export enum PermissionRoles {
  admin = 1,
  moderator = 2,
  supervisor = 3,
}

export enum PermissionsTypes {
  profile = 'profile',
  course = 'course',
}
